import {
  theme,
  useBreakpoint,
} from '@eCommerce/frontend-legacy-shared-library-native';
import React, {ReactNode} from 'react';
import {ThemeProvider} from 'styled-components/native';

const ConnectedThemeProvider: React.FunctionComponent<{
  children: ReactNode;
}> = ({children}) => {
  const breakpoint = useBreakpoint();

  return (
    <ThemeProvider
      theme={{
        ...theme,
        breakpoint,
      }}>
      {children}
    </ThemeProvider>
  );
};

export default ConnectedThemeProvider;
